import React from 'react'

import clsx from 'clsx'

import Review from 'components/Review'

import LABEL from './constants'

import classes from './ReviewsRecommendation.module.scss'

/** @type {import("./types").default} */
const ReviewsRecommendation = ({ recommendPercentage, reviews, gridIndex, gridSize, isMobileTablet }) => {
  const hasNoReviews = reviews.total_number === 0
  const showPercentage = !hasNoReviews && recommendPercentage !== null
  return (
    <div
      className={clsx('ReviewsRecommendation', classes.container, {
        [classes.noReviewsContainer]: hasNoReviews && gridIndex !== 0,
      })}
    >
      <div className={isMobileTablet ? classes.percentageRecommendSticky : classes.percentageRecommend}>
        {showPercentage && (
          <Review.PercentLabelDisplay
            hideLabelInMobileTablet={gridSize > 1}
            label={LABEL}
            recommendPercentage={recommendPercentage}
          />
        )}
      </div>
      {isMobileTablet && gridIndex === 0 && (
        <div className={clsx(classes.label, classes[`label-width-${gridSize}`])}>
          <div className={clsx(classes.sticky, classes[`sticky-width-${gridSize}`])}>{LABEL}</div>
        </div>
      )}
    </div>
  )
}

export default ReviewsRecommendation
